import script from "./Ayuda.vue?vue&type=script&setup=true&lang=js"
export * from "./Ayuda.vue?vue&type=script&setup=true&lang=js"

import "./Ayuda.vue?vue&type=style&index=0&id=6596eb67&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6596eb67"]])

export default __exports__